import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Parents = () => {
  return (
    <main id="main-content" className="bg-white">
      <Navbar />
      
      {/* Header Section */}
      <section className="pt-32 pb-24 bg-[#630503] relative overflow-hidden">
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-1/5 bg-gradient-to-b from-[#630503] to-white"></div>

        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            {/* Header Section */}
            <div className="mb-16">
              <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-6 py-3 text-sm font-medium uppercase tracking-[0.2em] mb-8 rounded-full">
                Parent Resources
              </span>
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-8 leading-[1.1] max-w-4xl mx-auto">
                Parent <span className="font-bold">Information Hub</span>
              </h1>
              <div className="w-24 h-px bg-white/40 mx-auto mb-8"></div>
              <p className="text-lg lg:text-xl leading-relaxed text-white/95 max-w-3xl mx-auto">
                Everything you need to know to support your child's educational journey at P.S. 11X The Highbridge School.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Essential Information */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* School Hours */}
            <div className="text-center">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">School Hours</h2>
              <div className="text-4xl font-light text-[#630503] mb-4">7:30 AM - 2:20 PM</div>
              <p className="text-gray-600">Monday through Friday</p>
            </div>

            {/* School Uniform */}
            <div className="text-center">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">School Uniform</h2>
              <div className="space-y-3">
                <div className="text-lg text-gray-700">Maroon</div>
                <div className="text-lg text-gray-700">Gray</div>
                <div className="text-lg text-gray-700">White</div>
              </div>
            </div>

            {/* Parent Support */}
            <div className="text-center">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">Parent Support</h2>
              <p className="text-gray-600 mb-6">Parent Coordinator available to help with any questions or concerns</p>
              <a href="tel:718-329-8000" className="bg-[#630503] text-white px-8 py-3 font-medium hover:bg-[#4a0402] transition-colors inline-block">
                Call (718) 329-8000
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Important Meetings & Events */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Important <span className="font-bold">Meetings & Events</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto"></div>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Meetings Column */}
            <div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-8">Regular Meetings</h3>
              <div className="space-y-8">
                <div>
                  <h4 className="text-xl font-medium text-gray-900 mb-2">PA Meetings</h4>
                  <p className="text-gray-600">3rd Wednesday of each month</p>
                </div>
                
                <div>
                  <h4 className="text-xl font-medium text-gray-900 mb-2">Coffee with the Principal</h4>
                  <p className="text-gray-600">Last Wednesday of each month</p>
                </div>
                
                <div>
                  <h4 className="text-xl font-medium text-gray-900 mb-2">New Families Orientation</h4>
                  <p className="text-gray-600">Monthly from October - April</p>
                </div>
              </div>
            </div>
            
            {/* Resources Column */}
            <div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-8">Important Resources</h3>
              <div className="space-y-6">
                <div>
                  <h4 className="text-lg font-medium text-gray-900 mb-4">NYC DOE Calendar</h4>
                  <div className="space-y-3">
                    <span className="block text-[#630503]">
                      2024-2025 School Year
                    </span>
                    <span className="block text-[#630503]">
                      2025-2026 School Year
                    </span>
                    <span className="block text-[#630503]">
                      Summer Rising Information
                    </span>
                  </div>
                </div>

                <div className="pt-6 border-t border-gray-200">
                  <h4 className="text-lg font-medium text-gray-900 mb-4">Required Accounts</h4>
                  <div className="space-y-3">
                    <span className="block text-[#630503]">
                      Create NYSCAA Account
                    </span>
                    <span className="block text-[#630503]">
                      MySchools Account
                    </span>
                    <span className="block text-[#630503]">
                      DOE / District 9 Links
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Get Involved Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Get <span className="font-bold">Involved</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto"></div>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Volunteering */}
            <div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-6">Volunteer Opportunities</h3>
              <p className="text-gray-600 mb-8 text-lg">Interested in volunteering? Contact our volunteer coordinators:</p>
              <div className="space-y-4 mb-8">
                <div>
                  <p className="text-xl font-medium text-gray-900">Ms. Jeannette Rodriguez</p>
                </div>
              </div>
            </div>
            
            {/* Parent Association */}
            <div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-6">Parent Association</h3>
              <p className="text-gray-600 mb-8 text-lg">Join our active parent community and make a difference in your child's education.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Specialized Support Programs */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Specialized <span className="font-bold">Support Programs</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Resources for families with specific needs</p>
          </div>
          
          <div className="space-y-16">
            {/* Special Education */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Special Education Support</h3>
                <p className="text-lg text-gray-600 mb-6">Contact: <span className="font-medium text-gray-900">Ms. Sirleaf</span></p>
                <div className="space-y-4">
                  <div>
                    <span className="text-[#630503] text-lg">
                      Bridging Connections Support Group
                    </span>
                    <p className="text-gray-600 mt-1">For families of students with Autism</p>
                  </div>
                  <span className="block text-[#630503] text-lg">
                    Special Education Tools & Resources
                  </span>
                </div>
              </div>
              <div className="lg:text-right">
                <div className="text-6xl font-light text-[#630503]/50">IEP</div>
              </div>
            </div>

            <div className="w-full h-px bg-gray-200"></div>

            {/* Dual Language */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="lg:order-2">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Dual Language Program</h3>
                <p className="text-lg text-gray-600 mb-6">Contact: <span className="font-medium text-gray-900">Ms. Urteaga</span></p>
                <div className="space-y-4">
                  <span className="block text-[#630503] text-lg">
                    Dual Language Parent Academy
                  </span>
                  <span className="block text-[#630503] text-lg">
                    Dual Language Tools & Resources
                  </span>
                </div>
              </div>
              <div className="lg:order-1">
                <div className="text-6xl font-light text-[#630503]/50">DL</div>
              </div>
            </div>

            <div className="w-full h-px bg-gray-200"></div>

            {/* Temporary Housing */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Temporary Housing Support</h3>
                <p className="text-lg text-gray-600 mb-6">Contact: <span className="font-medium text-gray-900">Ms. Mota</span></p>
                <div className="space-y-4">
                  <span className="block text-[#630503] text-lg">
                    SMART Stars Events
                  </span>
                  <span className="block text-[#630503] text-lg">
                    PATH Website
                  </span>
                  <span className="block text-[#630503] text-lg">
                    Title 1 STH Survey
                  </span>
                </div>
              </div>
              <div className="lg:text-right">
                <div className="text-6xl font-light text-[#630503]/50">STH</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default Parents;